import { API_TYPE } from "../../utils/config";

export const GET_TRANSFER_SEARCH = API_TYPE("GET_TRANSFER_SEARCH");
export const RESET_GET_TRANSFER_SEARCH = "RESET_GET_TRANSFER_SEARCH";

export const GET_TRANSFER_LIST = API_TYPE("GET_TRANSFER_LIST");
export const RESET_GET_TRANSFER_LIST = "RESET_GET_TRANSFER_LIST";

export const SET_SELECTED_TRANSFER = 'SET_SELECTED_TRANSFER';
export const RESET_SELECTED_TRANSFER = 'RESET_SELECTED_TRANSFER';

export const GET_TRANSFER_PREBOOK = API_TYPE("GET_TRANSFER_PREBOOK");

export const GET_TRANSFER_CHECKOUT = API_TYPE("GET_TRANSFER_CHECKOUT");
